import * as React from "react"

import cn from "@/util/cn"

export type TextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        "block w-full rounded-md border-0 px-3 py-2 text-base leading-6 ring-1 ring-inset ring-input placeholder:text-primary-contrast/60 focus:ring-2 focus:ring-inset focus:ring-primary",
        "disabled:cursor-not-allowed disabled:text-primary-contrast/60",
        className
      )}
      ref={ref}
      {...props}
    />
  )
)
Textarea.displayName = "Textarea"

export { Textarea }
